export default "__VITE_ASSET__DyeipV0w__"